import { makeShare } from '../../../utils/wz.v2'

function setShare(_, shareInfo) {
  makeShare(shareInfo)
}

export default {
  setShare
}
